import React, { useEffect, useState } from "react";
import Footer from "../components/Navbar/Footer";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Logo from "../assets/images/logo-white.png";
import { API_URL } from "../components/network/Api";
import { post } from "../utils/helpers/http";
import { useNavigate } from "react-router-dom";

const Resetpassword = () => {
  const [disableSaveBtn, setDisableSaveBtn] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    isTokenValid()
  }, [])

  const isTokenValid = async () => {
    const token = new URLSearchParams(window.location.search).get("token");
    console.log("*********** Token *****", token);
    // https://laundrygoapps.24livehost.com/v1/Account/IsTokenExist?token=dfgvdfgvfdgv
    try {
      const response = await post(`/Account/IsTokenExist?token=${token}`, {});
      console.log("response*is valid token****", response);
    }  catch (error) {
      if (error.response.status === 498) {
        // toast.error("Invalid token. Please create a new link to reset your password.");
        setDisableSaveBtn(true);
        setTimeout(() => {
          setDisableSaveBtn(false);
          navigate("/Invalid-token");
          setDisableSaveBtn(false); 
        },1000);
      }
      console.log("response*is valid token error ****", error);
    }
  }
  const validationSchema = Yup.object().shape({
    password: Yup.string()
      .required("Password is required")
      .min(8, "Password must be at least 8 characters")
      .max(12, "Password must be at most 12 characters")
      .matches(
        /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[a-zA-Z]).{8,}$/,
        "Password must contain at least 1 capital letter, 1 lower letter, 1 special character, and 1 numeric character"
      ),
    confirmPassword: Yup.string()
      .required("Confirm Password is required")
      .oneOf([Yup.ref("password"), null], "Passwords must match"),
  });



  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const response = await axios.post(
        `${API_URL}/Account/ResetPassword`,
        {
          password: values.password,
          confirmPassword: values.confirmPassword,
          token: new URLSearchParams(window.location.search).get("token"),
        },
        {
          headers: {
            UtcOffsetInSecond: 19800,
            AppVersion: 1,
          },
        }
      );
      if (response.status === 202) {
        toast.warning(response.data.message);
      } else {
        // toast.success(response.data.message);
        setTimeout(() => {
          window.location.href = "/thank-you";
        }, 1000);
      }
     
    } catch (error) {
      if (error.response && error.response.status === 400) {
        toast.error("Password format is not matched");
      } else {
        toast.error(error.response.data.message);
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="accountBox">
      <div className="accountLeft">
        <div className="logo_account mb-5">
          <img src={Logo} alt="logo" />
        </div>
      </div>
      <div className="accountRight">
        <div className="account-body mt-auto">
          <div className="logo_account d-xl-none mb-5 text-center">
            <img
              src={require("../assets/images/logo.png")}
              height="80"
              alt="logo"
            />
          </div>
          <h3 className="text-center mb-4">
            <strong>Reset Password</strong>
          </h3>
          <Formik
            initialValues={{ password: "", confirmPassword: "" }}
            validationSchema={validationSchema}
            validateOnChange={true}
            validateOnBlur={true}
            onSubmit={handleSubmit} >
            {({ isSubmitting, touched, errors }) => (
              <Form>
                <div className="form-group mb-3">
                  <label className="form-label">New Password</label>
                  <Field
                    type="password"
                    className="form-control"
                    name="password"
                    disabled={disableSaveBtn}
                  />
                  <ErrorMessage
                    name="password"
                    component="div"
                    className="text-danger"
                  />
                </div>
                <div className="form-group mb-3">
                  <label className="form-label">Confirm Password</label>
                  <Field
                    type="password"
                    className="form-control"
                    name="confirmPassword"
                    disabled={disableSaveBtn}
                  />
                  <ErrorMessage
                    name="confirmPassword"
                    component="div"
                    className="text-danger"
                  />
                </div>
                <div className="form-group mt-4">
                  <button
                    type="submit"
                    className="btn btn-primary w-100"
                    disabled={disableSaveBtn}
                  >
                    Save
                  </button>

                  {/* <button
                    type="submit"
                    className="btn btn-primary w-100"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Saving..." : "Save"}
                  </button> */}
                </div>
              </Form>
            )}
          </Formik>
           <div className="mt-5 text-center">
            <a href="/">
              <i className="fa-solid fa-arrow-left-long"></i> &nbsp;Back to
              Login
            </a>
          </div> 
        </div>
        <Footer />
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        draggable
        onOpen={() => {
          setDisableSaveBtn(true);
          setTimeout(() => {
            setDisableSaveBtn(false);
          }, 5000);
        }}
      />
    </div>
  );
};

export default Resetpassword;


